import Animation from "./Components/Animation";
import * as S from "./styles";

const SplashScreen = () => {
  return (
    <S.Wrapper>
      <S.Container>
        <Animation />
      </S.Container>
    </S.Wrapper>
  );
};

export default SplashScreen;
